import React, { forwardRef } from 'react';
import TextField from '@mui/material/TextField';
import { FormHelperText } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useEntityPermission } from '../../providers/EntityPermissionProvider/index';
import ReadOnly from './ReadOnly';
import ReadMoreText from '../UI/ReadMoreText';

const TextArea = forwardRef(
  ({ error, helperText, overwriteProps = {}, ...props }, ref) => {
    const { getValues } = useFormContext();
    const { isHidden, isReadOnly } = useEntityPermission();

    const currentvalue = getValues(props?.name);

    if (isReadOnly(props?.permission, currentvalue)) {
      return (
        <ReadOnly name={props?.name}>
          <ReadMoreText maxChars={props?.field?.limitText || 500}>
            {currentvalue}
          </ReadMoreText>
        </ReadOnly>
      );
    }

    if (isHidden(props?.permission)) {
      return <input type="hidden" name={props?.name} value={currentvalue} />;
    }
    return (
      <>
        <TextField
          sx={{
            '& .MuiInputBase-multiline': {
              padding: '6px 10px',
            },
          }}
          {...props}
          ref={ref}
          multiline
          rows={props.rows || 4}
          variant="outlined"
          fullWidth
          error={!!error}
          helperText={helperText}
          {...overwriteProps}
        />
        {error || helperText ? (
          <FormHelperText sx={{ typography: 'body2' }} error={Boolean(error)}>
            {error || helperText}
          </FormHelperText>
        ) : null}
      </>
    );
  },
);

export default TextArea;
